// Shared shapes for the admin Image Studio (mirrors
// Admin::ImageStudioController#studio_image_json).

export type StudioImageStatus = "queued" | "generating" | "ready" | "failed"

export type StudioImageJson = {
  id: number
  description: string
  prompt: string | null
  purpose: string
  style: string | null
  aspect_ratio: string
  brand: string
  batch_id: string
  status: StudioImageStatus
  provider_model: string | null
  error_message: string | null
  cost_estimate_cents: number | null
  reference_count: number
  in_library: boolean
  created_at: string
  image_url: string | null
  download_url: string | null
}

export const PURPOSE_LABELS: Record<string, string> = {
  photo: "Photograph",
  composite: "Edit / composite photos",
  poster: "Poster / text graphic",
  illustration: "Illustration",
}

export const MODEL_LABELS: Record<string, string> = {
  "fal-ai/flux/dev": "FLUX (photoreal)",
  "fal-ai/nano-banana": "Nano Banana (all-round)",
  "fal-ai/nano-banana/edit": "Nano Banana Edit (uses references)",
  "fal-ai/ideogram/v3": "Ideogram 3 (text on image)",
}

export const ASPECT_LABELS: Record<string, string> = {
  "1:1": "Square 1:1",
  "4:3": "Landscape 4:3",
  "3:4": "Portrait 3:4",
  "16:9": "Wide 16:9",
  "9:16": "Tall 9:16",
}
